export const docsAddress = "https://datasonnet.github.io/datasonnet-mapper/";
export const repoAddress = "https://github.com/datasonnet/datasonnet-mapper";
